import { render, staticRenderFns } from "./horizontal-result-card.component.vue?vue&type=template&id=69ca415a&scoped=true"
import script from "./horizontal-result-card.component.vue?vue&type=script&lang=ts"
export * from "./horizontal-result-card.component.vue?vue&type=script&lang=ts"
import style0 from "./horizontal-result-card.component.vue?vue&type=style&index=0&id=69ca415a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca415a",
  null
  
)

export default component.exports